import axios from 'axios';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';

const isEverad = process.env.CPA_ENV === 'everad';
/**
 * @param {object} options
 * @param {string|array} options.uri - request uri
 * @param {string} options.method - request method
 * @param {array} options.actions - actions type for http request lifecycle
 * @param {object} options.data - request data
 * @params {object} options.addToResponse - mixin additional data to response object (mixinData)
 *
 * @return {function}
 */
export default (options) => {
	const { url, method, actions, data = {}, addToResponse = {} } = options;
	const [ SUCCESS, ERROR ] = actions;
	return dispatch => {
		if (isString(url)) {
			return makeRequest(url, method, data)
				.then(res => dispatch(requestSuccess(SUCCESS, mixinToPayload(res, addToResponse), addToResponse)))
				.catch(error => dispatch(requestError(ERROR, error, {url, method, data})));
		}

		if (isArray(url) && url.length) {
			const series = url.map((itemUrl, index) => {
				const requestData = isArray(data) ? data[index] : data;
				return makeRequest(itemUrl, method, requestData);
			});
			return axios.all(series)
				.then(res => dispatch(requestSuccess(SUCCESS, res, addToResponse)))
				.catch(error => dispatch(requestError(ERROR, error, {url, method, data})));
		}
	};
};

const makeRequest = (url, method, data) => {
	return axios({url, method, [method === 'get' ? 'params' : 'data']: data});
};

// request lifecycle actions
const requestSuccess = (type, payload, meta = null) => ({ type, payload, meta });

const requestError = (type, error, requestData) => {
	if (error.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		const {data, status} = error.response;
		// const logData = {
		// 	data, status
		// };
		if (process.env.CPA_ENV === 'everad' && process.env.NODE_ENV === 'production') {
			const rollbarMsg = data && data.message ? `${status}. ${data.message}` : `${status}. Error on API request`;
			Rollbar && Rollbar.warning(rollbarMsg, { data, status });
		}

		if (!status || (status >= 500 || status < 400)) {
			// trackJs.track(`Got server error extended. ${JSON.stringify(logData)}`);
			// trackJs.console.error('Log server error', {logData, requestData});
		}
		if (status === 403 && data && data.message === 'affiliate was deactivated') {
			window.location.href = isEverad
				? 'https://everad.com?is-deactivated=true'
				: 'https://rocketprofit.com?is-deactivated=true';

			return;
		}
	} else if (error.request) {
		// The request was made but no response was received
		// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
		// http.ClientRequest in node.js
		// trackJs.track(error.request);
	} else {
		// Something happened in setting up the request that triggered an Error
		throw error;
	}
	return { type, payload: error};
};

// add data to payload
const mixinToPayload = (payload, mixinData) => ({ ...payload, mixinData });



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/http.js